import React from 'react'
import { Box } from '@material-ui/core'
import { mutualTheme } from '~/utils/theme'
import { DocumentBox } from '../DocumentBox'
import { makeStyles } from '@material-ui/styles'
import { translateDocumentPendencyStatus } from '~/utils/documents'
import { DocumentAnalysisStatus } from '@mutual-services/account-documents-types'

type BadgeType = 'error' | 'success' | 'info' | 'warning'

export type LoanRequestStatusBadgeProps = {
  status: DocumentAnalysisStatus,
  solicitationDate: string
}

const getStatusBadgeType = (status: DocumentAnalysisStatus): BadgeType => {
  switch (status) {
    case DocumentAnalysisStatus.APPROVED:
      return 'success'
    case DocumentAnalysisStatus.PENDING_ANALYSIS:
      return 'info'
    case DocumentAnalysisStatus.PENDING:
      return 'warning'
    default:
      return 'info'
  }
}

const useStyles = makeStyles({
  container: (props: LoanRequestStatusBadgeProps) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: mutualTheme.spacing(3),
    paddingLeft: mutualTheme.spacing(4),
    paddingRight: mutualTheme.spacing(4),
    paddingBottom: mutualTheme.spacing(3),
    borderRadius: mutualTheme.shape.borderRadius,
    backgroundColor: mutualTheme.palette.badgeBackgroundColor[getStatusBadgeType(props.status)].dark,
    [mutualTheme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: mutualTheme.spacing(2)
    }
  }),
  text: {
    color: mutualTheme.palette.common.white
  }
})

export const LoanRequestStatusBadge: React.FC<LoanRequestStatusBadgeProps> = (props) => {
  const { status, solicitationDate } = props
  const classes = useStyles(props)
  const formatedStatus = status === DocumentAnalysisStatus.APPROVED ? DocumentAnalysisStatus.PENDING_ANALYSIS : status

  return (
    <Box className={classes.container}>
      <DocumentBox
        icon='CalendarIcon'
        textClassName={classes.text}
        description={solicitationDate}
        title='Solicitação iniciada em'
        iconColor={mutualTheme.palette.badgeBackgroundColor[getStatusBadgeType(status)].light}
      />
      <DocumentBox
        title='Status:'
        icon='ThreeDotsIcon'
        textClassName={classes.text}
        description={translateDocumentPendencyStatus(formatedStatus)}
        iconColor={mutualTheme.palette.badgeBackgroundColor[getStatusBadgeType(status)].light}
      />
    </Box>
  )
}
